/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetVatExemptionListModel } from '../../models/get-vat-exemption-list-model';
import { VatExpemtionsResponseModel } from '../../models/vat-expemtions-response-model';

export interface PostApiVatexemptionV1$Json$Params {

/**
 * Optional Impersonation User header
 */
  'X-Impersonated-User'?: string;
      body?: GetVatExemptionListModel
}

export function postApiVatexemptionV1$Json(http: HttpClient, rootUrl: string, params?: PostApiVatexemptionV1$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<VatExpemtionsResponseModel>> {
  const rb = new RequestBuilder(rootUrl, postApiVatexemptionV1$Json.PATH, 'post');
  if (params) {
    rb.header('X-Impersonated-User', params['X-Impersonated-User'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VatExpemtionsResponseModel>;
    })
  );
}

postApiVatexemptionV1$Json.PATH = '/private/v1/vat-exemptions';
